<template>
    <div id="cookie-consent" v-if="requireConsent">
        <Modal v-if="showDetails" @dismiss="showDetails = false">
            <p>
                This website uses cookies. Some cookies are essential to the functionality of the website. Others are
                used to improve the user experience.
            </p>
            <div class="cookie-categories">
                <div :data-expanded="`${expanded.includes('necessary')}`">
                    <i class="material-icons" @click="toggle('necessary')">chevron_right</i>
                    <span class="category-name">Necessary</span>
                    <span>Always Enabled</span>
                    <p>
                        These cookies are used for authentication and for display of your name and organization
                        information while signed in. They are also used to store your cookie preferences.
                    </p>
                </div>
                <div v-for="cookie in editing" :key="cookie.key" :data-expanded="`${expanded.includes(cookie.key)}`">
                    <i class="material-icons" @click="toggle(cookie.key)">chevron_right</i>
                    <span class="category-name">{{ cookie.display }}</span>
                    <span><mt-switch v-model="cookie.value" /></span>
                    <p>{{ cookie.description }}</p>
                </div>
            </div>
            <div class="button-group">
                <button class="primary" @click="save">Accept & Save</button>
            </div>
        </Modal>
        <div class="mini-consent" v-else>
            <div>
                We use cookies to improve your experience. We'll assume you're ok with this, but you can opt-out if you
                wish.
            </div>
            <div class="button-group">
                <a class="primary-link" href="#" @click.prevent="showDetails = true">Cookie Settings</a>
                <button class="primary" @click="acceptAll">Accept</button>
            </div>
        </div>
    </div>
</template>
<script setup>
import Modal from './shared/modal.vue'
import { computed, ref } from 'vue'
import { gdpr } from '@/utils/gdpr'

const showDetails = ref(false)

const requireConsent = computed(() => {
    let updated = gdpr.updated ? Date.parse(gdpr.updated) : null

    if (!updated || updated == 'Invalid Date') {
        return true
    }

    return false
})

const editing = ref(gdpr.all)

function acceptAll() {
    gdpr.acceptAll()
    showDetails.value = false
}

function save() {
    const selections = Object.fromEntries(editing.value.map(c => [c.key, c.value]))
    gdpr.accept(selections)
    showDetails.value = false
}

function toggle(category) {
    const index = expanded.value.indexOf(category)

    if (index > -1) {
        expanded.value.splice(index, 1)
    } else {
        expanded.value.push(category)
    }
}

const expanded = ref([])
</script>
<style scoped>
#cookie-consent {
    position: absolute;
    left: 0;
    top: 0;
}

.mini-consent {
    background: white;
    bottom: calc(-100dvh + 16px);
    box-shadow: var(--boxshadow-default);
    display: flex;
    flex-direction: column;
    gap: 16px;
    left: 40px;
    padding: 16px;
    position: absolute;
    width: 360px;
    z-index: var(--z-index-menu);
}

#cookie-consent .button-group {
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    margin: 0;
    width: 100%;
}

#cookie-consent :deep(.modal) {
    max-width: 420px;
}

#cookie-consent :deep(.modal-header) {
    margin: 0;
    padding: 0;
}

#cookie-consent :deep(.modal-body) {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin: 0;
    padding: 0 16px;
}

#cookie-consent :deep(.modal-footer) {
    display: none;
}

.cookie-categories {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.cookie-categories > div {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
}

i {
    cursor: pointer;
    transition: transform 0.1s;
}

[data-expanded='true'] i {
    transform: rotate(90deg);
}

.category-name {
    flex: 1 0 auto;
}

.cookie-categories p {
    padding: 0 24px;
    width: 100%;
}

[data-expanded='false'] p {
    display: none;
}

@media (max-width: 480px) {
    .mini-consent {
        left: 0;
        bottom: -100dvh;
        width: 100dvw;
    }
}
</style>
